import { getMetadataStacks, getModuleSettings } from '@signiapp/signature/services/signature';
export default {
  getMetadataStacks: getMetadataStacks,
  getModuleSettings: getModuleSettings
};